import type { Metadata } from "next";
import "./globals.css";
import "./brand.css";

const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export const metadata: Metadata = {
  metadataBase: new URL("https://ncore-3d-platform.pijunyel2.chatgpt.site"),
  title: "Naon 3D Platform | NModeler",
  description: "Google Play에 출시된 Android용 3D 파일 뷰어·변환 도구 NModeler와 개발 중인 NScanner를 소개합니다.",
  keywords: ["Naon","NModeler","NScanner","3D 모델","3D 파일 변환","GLB","GLTF","FBX","OBJ","STL","Android"],
  alternates: { canonical: "/" },
  icons: { icon: `${basePath}/naon-icon.svg` },
  openGraph: { title:"Naon 3D Platform | NModeler", description:"Android에서 3D 파일을 열고 확인하고 변환하세요.", type:"website", locale:"ko_KR", url:"/", siteName:"Naon 3D Platform", images:[{url:`${basePath}/nmodeler-feature-2026.png`,width:1024,height:500,alt:"NModeler — View, Inspect, Transform, Export"}] },
  twitter: { card:"summary_large_image", title:"Naon 3D Platform | NModeler", description:"Android에서 3D 파일을 열고 확인하고 변환하세요.", images:[`${basePath}/nmodeler-feature-2026.png`] },
};
export default function RootLayout({children}:{children:React.ReactNode}) { return <html lang="ko"><body>{children}</body></html>; }
